export const safeParseJSON = (jsonString) => {
    try {
        return JSON.parse(jsonString);
    }
    catch (error) {
        const errorObject = error instanceof Error ? error : new Error("Unknown error");
        console.error("Failed to parse JSON:", errorObject);
        newrelic.noticeError(errorObject);
        return undefined;
    }
};
//# sourceMappingURL=safeParseJSON.js.map